import React from "react";
import RenderSectionTitle from "./RenderSectionTitle";
import RenderSubSectionTitle from "./RenderSubSectionTitle";
import {
  getEntitiesFor,
  getEntitiesForSubsection,
  getSubsectionsOf,
} from "./DataFlowHelper";
import _ from "lodash";

function getTableStyle(examNotes, examObservations) {
  if (examNotes.length === 0 && examObservations.length > 0) {
    return {
      width: "100%",
    };
  }

  if (examNotes.length > 0 && examObservations.length > 0) {
    return {
      width: "74%",
      marginRight: "1%",
    };
  }
}

function getExamNotesStyle(examNotes, examObservations) {
  if (examNotes.length > 0 && examObservations.length === 0) {
    return {
      width: "100%",
    };
  }
  if (examNotes.length > 0 && examObservations.length > 0) {
    return {
      width: "24%",
    };
  }
}

function ExaminationDetails({
  // examEntities,
  // examNotes,
  // examObservations,
  // examDiagnosisNotes,
  // renderObservationsTable,
  // sectionNames,
  entities,
  sectionMaps,
  subSectionMaps,
  renderObservationsTable,
  styleOptions,
  renderOptions,
}) {
  const sectionEntities = getEntitiesFor(entities, "EXAMINATION");
  if (sectionEntities.length === 0) return null;
  const EXAMINATION_SubSectionList = getSubsectionsOf("EXAMINATION");

  const OBSERVATIONS_entities = getEntitiesForSubsection(
    sectionEntities,
    "OBSERVATIONS"
  );
  const DIAGNOSIS_entities = getEntitiesForSubsection(
    sectionEntities,
    "DIAGNOSIS"
  );
  const EXAMINATION_NOTES_entities = getEntitiesForSubsection(
    sectionEntities,
    "EXAMINATION_NOTES"
  );

  let tableStyle = getTableStyle(
    EXAMINATION_NOTES_entities,
    OBSERVATIONS_entities
  );
  let examNotesStyle = getExamNotesStyle(
    EXAMINATION_NOTES_entities,
    OBSERVATIONS_entities
  );

  const lateralityText = (laterality) => {
    if (renderOptions.expandedLaterality) {
      if (laterality === "LEFT") {
        return "LEFT EYE - ";
      } else if (laterality === "RIGHT") {
        return "RIGHT EYE - ";
      } else if (laterality === "BILATERAL") {
        return "BOTH EYES - ";
      }
    } else {
      if (laterality === "LEFT") {
        return "LE - ";
      } else if (laterality === "RIGHT") {
        return "RE - ";
      } else if (laterality === "BILATERAL") {
        return "BE - ";
      }
    }
  };

  const sectionTitleRender = sectionMaps["EXAMINATION"];

  return (
    <div style={styleOptions.mainContainerStyle}>
      <RenderSectionTitle text={sectionTitleRender} />
      <div style={styleOptions.tableContainerStyle}>
        {
          <div style={tableStyle}>
            {OBSERVATIONS_entities.length > 0 && (
              <>
                {/*<RenderSubSectionTitle
                  text={subSectionMaps["EXAMINATION"]["OBSERVATIONS"]}
            />*/}
                <div style={{ width: "100%" }}>
                  {renderObservationsTable(OBSERVATIONS_entities)}
                </div>
              </>
            )}
          </div>
        }
        {EXAMINATION_NOTES_entities.length > 0 && (
          <div style={examNotesStyle}>
            <RenderSubSectionTitle
              // text={subSectionMaps["EXAMINATION"]["EXAMINATION_NOTES"]}
              text="Notes"
            />
            {EXAMINATION_NOTES_entities.map((each, index) => {
              return (
                <p style={styleOptions.notesBulletPointStyle}>
                  {each.entityName}
                </p>
              );
            })}
          </div>
        )}
      </div>
      {DIAGNOSIS_entities.length > 0 && (
        <div style={{ width: "100%" }}>
          <RenderSubSectionTitle
            text={subSectionMaps["EXAMINATION"]["DIAGNOSIS"]}
          />
          {DIAGNOSIS_entities.map((entity, index) => {
            let elements = [];
            let firstLine = [];
            firstLine.push(<>{index + 1}. </>);
            if (entity.laterality) {
              firstLine.push(<b>{lateralityText(entity.laterality)}</b>);
              // if (entity.laterality === "LEFT") {
              //   firstLine.push(<b>LE - </b>);
              // } else if (entity.laterality === "RIGHT") {
              //   firstLine.push(<b>RE - </b>);
              // } else if (entity.laterality === "BILATERAL") {
              //   firstLine.push(<b>BE - </b>);
              // }
            }
            firstLine.push(
              <b style={styleOptions.bulletPointTitleStyle}>
                {entity.entityName}
              </b>
            );
            if (entity.icd11 && entity.icd11 !== "") {
              elements.push(
                <div style={styleOptions.instructionStyle}>
                  <i>ICD11: {entity.icd11}</i>
                </div>
              );
            }
            if (entity.notes) {
              let text = <></>;
              let t = entity.notes.split(";");
              t = t.map((ee) => ee.split(","));
              t = _.flatten(t);
              t = t.map((ee) => _.upperFirst(ee.trim()));
              text = (
                <>
                  {t.map((ee) => {
                    return <div>{ee}</div>;
                  })}
                </>
              );

              elements.push(
                <div style={styleOptions.instructionStyle}>{text}</div>
              );
            }

            return (
              <div style={styleOptions.subSectionBulletPoint}>
                <div>
                  {firstLine.map((entity) => {
                    return <>{entity}</>;
                  })}
                </div>

                {elements.map((entity) => (
                  <div>{entity}</div>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ExaminationDetails;
